<template>
  <div class="add_testpaper_wrap">
    <div class="add_testpaper_title">
    	<div class="goback" @click="goBack">
				<img src="../../../../static/images/course/icon-3.png"/>
				<span>返回</span>
			</div>
      <h2>{{title}}</h2>
      <div class="btn">
        <el-button @click="closeTestpaper">取消</el-button>
        <el-button @click="saveTest">保存</el-button>
      </div>
    </div>
    <div class="add_testpaper_main">
      <el-form :model="testForm" ref="testForm" class="test_form">
        <el-form-item prop="testname" label="测验名称：">
          <el-input v-model.trim="testForm.testname" placeholder="请输入测验名称" maxlength="20" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="isLimit" label="答题次数：">
          <el-radio-group v-model="testForm.isLimit" @change="changeNum">
            <el-radio :label="0">不限次</el-radio>
            <el-radio :label="1">限次</el-radio>
          </el-radio-group>
          <el-select v-model="testForm.limitNum" :disabled="selectFlag">
            <el-option v-for="i in 5" :key="i" :label="i" :value="i"></el-option>
          </el-select>
          <span>次</span>
        </el-form-item>
        <el-form-item prop="mode" label="作答模式：">
          <el-radio-group v-model="testForm.mode">
            <el-radio :label="0" :disabled="answerTypeFlag">练习模式</el-radio>
            <el-radio :label="1" :disabled="answerTypeFlag">挑战模式</el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="tips_p">练习模式：每次交卷后都显示正误和答题解析；挑战模式：最后一次交卷前显示正误，不显示答案解析； 最后一次交卷后显示正误和答案解析。</p>
      </el-form>
      <div class="select_test">
        <span>选择试卷：</span>
        <p @click="showTest()" v-if="JSON.stringify($store.state.testObj) == '{}'">
          <img src="../../../../static/images/course/add.png" alt="">
        </p>
        <div class="testMsg" v-else>
        	<div class="imgBox">
        		<img src="../../../../static/images/course/teachClassIcon/test.png"/>
        	</div>
        	<div class="right" v-if="!$route.query.paperId">
        		<li>{{$store.state.testObj.paperName}}</li>
        		<li>{{$store.state.testObj.totalScore}}分/{{$store.state.testObj.questionCount}}题</li>
        		<li>
        			<el-button type="primary" icon="el-icon-view" @click="previewRow()">预览</el-button>
        			<el-button type="primary" icon="el-icon-delete" class="del" @click="del()">删除</el-button>
        		</li>
        	</div>
        	<div class="right" v-else>
        		<li>{{$store.state.testObj.paperName}}</li>
        		<li>{{$store.state.testObj.paperScore}}分/{{$store.state.testObj.count}}题</li>
        		<li>
        			<el-button type="primary" icon="el-icon-view" @click="previewRow()">预览</el-button>
        		</li>
        	</div>
        </div>
      </div>
    </div>
    <!--选择试卷-->
		<el-drawer
		  title="选择试卷"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>选择试卷</span>
		  		<div class="btn">
		  			<el-button @click="cancelTestPaper">返回</el-button>
        		<el-button @click="saveTestPaper">保存</el-button>
		  		</div>
		  	</header>
		  	<div class="search_ipt">
		  		<h3 class="ipt">科目：{{$route.query.subjectName}}</h3>
					<!-- <div class="ipt">
						<el-select v-model="subject" placeholder="请选择所属专业科目" v-if="subjectList.length>0" @change="change">
              <el-option
                v-for="item in subjectList"
                :key="item.id"
                :label="item.name"
                :title="item.name"
                :value="item.id">
              </el-option>
            </el-select>
					</div> -->
		  		<div class="ipt">
		  			<el-date-picker
	            v-model="classStartTime"
	            type="date"
	            value-format="yyyy-MM-dd"
	            placeholder="请选择开始时间"
	            @change="changeEnd"
	            :picker-options="startDateLimit">
	          </el-date-picker>
		  		</div>
		  		<div class="ipt">
		  			<el-date-picker
	            v-model="classEndTime"
	            type="date"
	            @focus="changeEnd"
	            @change="setTime"
	            value-format="yyyy-MM-dd"
	            placeholder="请选择结束时间"
	            :picker-options="endDateLimit">
	          </el-date-picker>
		  		</div>
		  		<div class="ipt">
		  			<el-input class="ipt_name" v-model="testName" placeholder="请输入试卷名称"></el-input>
		  		</div>
		  		<div class="btn ipt">
		  			<el-button icon="el-icon-search" @click="search()">查询</el-button>
		  		</div>
		  	</div>
		  	<div class="table" :style="'height:'+height">
		  		<div class="header_title">
						<p></p>
						<p>试卷名称</p>
						<p>试卷用途</p>
						<p>总分/题</p>
						<p>创建时间</p>
					</div>
					<div class="teach_class" v-if="tableData.length>0">
						<li class="tab_item" v-for="(item,index) in tableData" :key="index">
							<p>
								<el-radio-group v-model="radio" @change="testChange">
							    <el-radio :label="item"><span></span></el-radio>
							  </el-radio-group>
							</p>
							<p><span style="color: red" v-if="item.authMark ===1">（授权）</span>{{item.paperName}}</p>
							<p>{{item.paperType | filterStatus}}</p>
							<p>{{item.totalScore}}分/{{item.questionCount}}题</p>
							<p>{{item.createTime.substring(0,10)}}</p>
						</li>
					</div>
					<div v-else>
						<p style="font-size:14px;text-align:center;margin-top:20%;">该专业科目下暂无试卷</p>
					</div>
		  	</div>
		  	<div class="pages-cont">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageTotal.currentPage"
            background
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageTotal.pageSize"
            :pager-count="5"
            layout="sizes, prev, pager, next, jumper"
            :total="pageTotal.total"
            class="paginator"
            v-if="pageTotal.total>10"
          ></el-pagination>
		  	</div>
		  </div>
		</el-drawer>
		<!-- 试卷加密弹窗 -->
		<el-dialog title="输入密码" width="400px" :visible.sync="dialogFormVisible">
		  <el-form :model="passForm" :rules="passRules" ref="passForm">
		    <el-form-item label="密码" label-width="60px">
		      <el-input type="password" v-model="passForm.passwordUse" autocomplete="off"></el-input>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="passConfim('passForm')">确 定</el-button>
		  </div>
		</el-dialog>
  </div>
</template>
<script>
import * as api from '../../../api/individualApi'
import * as courseApi from '../../../api/courseApi'
import Pagination from "../../paginator/paginator";
export default {
  components: {
    Pagination
  },
  data(){
    return{
      loading: true,
      treeData: [],
      height:window.innerHeight - 174+"px",
      pageTotal: {//分页
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      testForm: {
        testname: '',
        isLimit: 0,
        mode: 0,
        limitNum: 1,
        id:''
      },
      selectFlag: true,
      answerTypeFlag: true,
      drawer: false,
      direction:'rtl',
      testName:'',
      startDateLimit:{
        disabledDate:(time)=>{
          if (this.classEndTime) {
            return time.getTime() > new Date(this.classEndTime).getTime();
          }else{//还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
            // return time.getTime() < Date.now() - 8.64e7
          } 
        }
      },
      endDateLimit:null,
      classStartTime:'',
      classEndTime:'',
      radio:null,
      tableData:[],
      subjectID: this.$route.query.subjectId,
      testObj:{},
      title: '',
      authMark:'', // 0：非授权；1：授权
			passForm: {
				passwordUse: ''
			},
			passRules: {
				passwordUse: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
			},
			dialogFormVisible: false,
			subjectList: [],
			subject: ""
    }
  },
  mounted(){
		this.getList()
  	if(this.$route.query.paperId){
  		this.title = '编辑测验';
  		this.echoTestMsg();
  		this.echoTest();
  	}else{
  		this.title = '添加测验'
  		this.$store.state.testObj = {};
  	}
  },
  filters: {
    formatTime(time) {
      return (time = time.slice(0, 10) + " " + time.slice(11, 19));
    },
		filterStatus(paperType){
			let str = "";
			switch (paperType) {
				case 1:
						str = "考试";
						break;
				case 2:
						str = "测验";
						break;
				case 3:
						str = "大赛";
						break;
				case 4:
						str = "综合实训";
						break;
			}
			return str;
		}
  },
  methods:{
			getList(){//获取所有专业科目
				let that = this
				let professional = sessionStorage.getItem('professional')
				courseApi.getSubjectList().then((rs)=>{
					if(rs.code==0){
						that.subjectList = []
						let obj = {}
						rs.data.forEach((item,i)=>{
							if(item.professionId == professional){
								obj = {
									id: item.id,
									name: item.name,
									professionId: item.professionId
								}
								that.subjectList.push(obj)
							}
						})
						this.subject = Number(this.subjectID)
					}
				}).then(()=>{
					this.getTestPaper(this.subjectID)
				}).catch((error)=>{
					console.log(error)
				})
		},
		change(val){//选择科目
			this.pageTotal.currentPage = 1;
			this.subjectID = val
			this.getTestPaper(this.subjectID);
			this.testObj = {};
			this.radio = null
		},
  	// 获取试卷
  	getTestPaper(id){
  		let obj = {
  			paperName: this.testName,
        subjectId: id,
        beginTime: this.classStartTime,
        endTime: this.classEndTime,
        pageNo: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        paperType: '2',
        status: 1
  		};
  		api.getPaperList(obj).then(res=>{
  			console.log(res);
  			if(res.code == 0){
  				this.tableData = res.data.testPaperList;
  				this.pageTotal.total = res.data.totalCount;
  			}
  		})
  	},
  	//编辑测验信息回显
  	echoTestMsg(){
  		api.examEcho(this.$route.query.courseId,this.$route.query.paperId).then(res=>{
  			console.log(res);
  			if(res.code == 0){
  				if(res.data.examCount == -1){
  					this.testForm.isLimit = 0;
  					this.selectFlag = true;
  					this.answerTypeFlag = true;
  				}else{
  					this.testForm.isLimit = 1;
  					this.selectFlag = false;
  					this.answerTypeFlag = false;
  					this.testForm.limitNum = res.data.examCount;
  				}
  				this.testForm.testname = res.data.examName;
  				this.testForm.mode = res.data.examMode;
  				this.testForm.id = res.data.id;
  			}
  		})
  	},
  	// 编辑测验试卷回显
  	echoTest(){
  		api.getTestMsg(this.$route.query.paperId).then(res=>{
  			if(res.code == 0) {
  				this.$store.state.testObj = res.data;
  			}
  		})
  	},
  	handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      this.getTestPaper(this.subjectID);
   	},
   	handleSizeChange(val){
   		this.pageTotal.pageSize = val;
   		this.pageTotal.currentPage = 1;
      this.getTestPaper(this.subjectID);
   	},
    closeTestpaper(){
    	this.$router.go(-1);
//  	this.$store.state.catalogRetainId = this.$route.query.catalogId;
    },
    goBack(){
    	this.$router.go(-1);
//  	this.$store.state.catalogRetainId = this.$route.query.catalogId;
    },
    // 次数选择
  	changeNum(val){
  		if(val) {
  			this.selectFlag = false;
  			this.answerNum = 3;
  			this.answerTypeFlag = false;
  		}else{
  			this.selectFlag = true;
  			this.answerTypeFlag = true;
  			this.answerNum = '';
  			this.answerType = 0;
  		}
  	},
  	// 添加测验保存
  	saveTest(){
			console.log(this.$store.state.testObj)
  		if(!this.testForm.testname){
    		this.$messageError('请填写测验名称');
    		return
    	}
    	if(JSON.stringify(this.$store.state.testObj) == "{}"){
    		this.$messageError('请选择试卷');
    		return
    	}
    	if(this.$route.query.paperId){
    		let param = {
    			"examCount": this.testForm.isLimit?this.testForm.limitNum:'-1',
					"examMode": this.testForm.mode?'1':'0',
					"examName": this.testForm.testname,
					"id": this.testForm.id
    		}
    		api.saveEditorTest(param).then(res=>{
    			if(res.code == 0){
	    			this.$messageSuccess('编辑测验成功');
	  				this.$router.go(-1);
	  				this.$store.state.catalogRetainId = this.$route.query.catalogId;
	    		}else{
	    			this.$messageError(res.msg);
	    		}
    		})
    	}else{
    		let newArr = []
	      let obj = {};
	      obj.catalogId = this.$route.query.catalogId;
	      obj.courseId = this.$route.query.courseId;
	      obj.resourceId = this.$store.state.testObj.id;
	      obj.type = 5;
	      obj.examCount = this.testForm.isLimit?this.testForm.limitNum:'-1';
	      obj.examModel = this.testForm.mode?'1':'0';
	      obj.examName = this.testForm.testname;
	      newArr.push(obj);
	      let param = {
	        catalogId:this.$route.query.catalogId,
	        courseId:this.$route.query.courseId,
	        list:newArr
	      }
	    	api.saveTest(param).then(res=>{
	    		if(res.code == 0){
	    			this.$messageSuccess('添加测验成功');
	  				this.$router.go(-1);
	  				this.$store.state.catalogRetainId = this.$route.query.catalogId;
						api.checkPaperDecryption(this.$store.state.testObj.paperCode).then(res=>{
							if(res.code == 0 && res.data){
								let obj = {
									"paperId": this.$store.state.testObj.id,
									"operationContent": "使用了试卷"
								}
								api.addPaperOperationRecord(obj);
							}
						})
	    		}else{
	    			this.$messageError(res.msg);
	    		}
	    	})
    	}

  	},
  	// 选择试卷
  	showTest(){
  		this.drawer = true;
  		this.pageTotal.currentPage = 1;
  		this.testObj = {};
  		this.classStartTime = '';
      this.classEndTime = '';
      this.radio = null;
			this.subject = Number(this.$route.query.subjectId);
			this.getTestPaper(this.subject);
  	},
  	// 删除试卷
  	del(){
  		this.$store.state.testObj = {};
  	},
  	cancelTestPaper(){
  		this.drawer = false;
  	},
  	// 保存试卷
  	saveTestPaper(){
  		if(JSON.stringify(this.testObj) != '{}'){
				api.checkPaperDecryption(this.testObj.paperCode).then(res=>{
					if(res.code == 0){
						if(res.data){
							this.dialogFormVisible = true;
							this.passForm.passwordUse = ''
						}else{
							this.$store.state.testObj = this.testObj;
							this.drawer = false;
						}
					}
				})
  		}else{
  			this.$message.warning('请先选择要保存的试卷')
  		}
  	},
		// 试卷解密
		passConfim(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let param = {
						"paperCode": this.testObj.paperCode,
						"passwordUse": this.passForm.passwordUse
					}
					api.usePaperDecryption(param).then(res=>{
						if(res.code == 0 && res.data){
							this.$store.state.testObj = this.testObj;
							this.drawer = false;
							this.dialogFormVisible = false;
						}else{
							this.$messageError('密码错误，请重新输入');
							this.passForm.passwordUse = ''
						}
					})
				}
			});
		},
  	search(){
      this.handleCurrentChange(1);
      this.radio = null;
      console.log(this.radio);
  	},
  	testChange(val){
  		console.log(val);
  		this.testObj = val;
  	},
  	//time
    changeEnd(){
      //如果结束日期尚未选择
      if(!this.classStartTime){
        this.$message.warning('请先选择开始日期')
        this.endDateLimit = Object.assign({},this.endDateLimit,{
          disabledDate:(date)=>{
            return true
          }
        })
      }else{
        this.endDateLimit = Object.assign({},this.endDateLimit,{
          disabledDate: (time) => {
            if(this.classStartTime){
              return time.getTime() < new Date(this.classStartTime).getTime() - 1*24*60*60*1000;//可以选择同一天
            }
          }
        })
      }
    },
    setTime(){
      if(this.classEndTime){
        if(this.classStartTime > this.classEndTime){
          this.classEndTime = ''
          this.$message.warning('结束日期小于开始日期，请重新选择')
          return ;
        }
      }
    },
    // 预览
    previewRow(){
  		let paperId = ''
  		if(this.$store.state.testObj.id){
  			paperId = this.$store.state.testObj.id;
  		}else{
  			paperId = this.$route.query.paperId;
  		}
  		const { href } = this.$router.resolve({
        path: '/switch/test/preview',
        query: {
          paperId: paperId,
          id: this.$route.query.courseId
        }
      });
      window.open(href, '_blank');
    }
  }
}
</script>
<style lang="scss" scoped>
  .add_testpaper_wrap{
  	height: calc(100% - 32px);
    background: #fff;
    padding: 0 16px;
    margin: 16px 16px 0;
    border-radius: 4px;
    .add_testpaper_title{
      height: 64px;
      border-bottom: 1px solid #DDE0E2;
      position: relative;
      h2{
        font-size:16px;
        font-weight:bold;
        color:rgba(13,13,13,1);
        position: relative;
        line-height: 64px;
        margin-left: 82px;
      }
      .goback {
      	position: absolute;
				display: flex;
				align-items: center;
				cursor: pointer;
				top: 21px;
				img {
					display: inline-block;
					width: 18px;
					height: 18px;
				}
				span {
					font-size: 14px;
					padding: 0 8px;
					color: #858C96;
				}
				&::after{
          content:'';
          position: absolute;
          left: 66px;
          top: 5px;
          background: #5397F7;
          width: 4px;
          height: 12px;
        }
			}
      .btn{
        position: absolute;
        right: 20px;
        top: 17px;
        button{
          width:72px;
          height:28px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          color: #fff;
          padding: 0;
          font-size: 12px;
          &:hover{
            opacity: 0.8;
          }
          &:last-child{
            margin-left: 12px;
          }
        }
      }
    }
    .add_testpaper_main{
      padding: 16px 0 16px 16px;
      box-sizing: border-box;
      /deep/ .test_form{
        border-bottom: 1px solid #DDE0E2;
        padding-bottom: 16px;
        margin-right: 16px;
        .el-form-item{
          .el-form-item__label{
            font-size:12px;
            font-weight:400;
            line-height:28px;
            color:rgba(13,13,13,1);
            letter-spacing: 1px;
          }
          .el-form-item__content{
            line-height: 28px;
            .el-input{
              width: 266px;
              .el-input__inner{
                height: 28px;
                line-height: 28px;
                border: 0;
                background: #F1F2F4;
								border-radius: 2px;
              }
            }
            .el-select{
              width: 65px;
              .el-input{
                width: 65px;
                .el-input__suffix{
                  line-height: 28px;
                  .el-input__icon{
                    line-height: 28px;
                  }
                }
              }
            }
          }
        }
        .tips_p{
          font-size:12px;
          font-weight:400;
          color:rgba(133,140,150,1);
          letter-spacing: 1px;
          margin-left: 16px;
        }
      }
      .select_test{
        display: flex;
        margin-right: 16px;
        margin-top: 16px;
        span{
          min-width: 90px;
          line-height: 28px;
          font-size:12px;
          font-weight:400;
          color:rgba(13,13,13,1);
          letter-spacing: 1px;
          text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
        }
        p{
          width:120px;
          height:112px;
          background:rgba(241,242,244,1);
          border-radius:3px;
          position: relative;
          cursor: pointer;
          img{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 35px;
            height: 35px;
          }
        }
      }
      .testMsg {
      	display: flex;
      	justify-content: space-between;
      	.imgBox {
      		width: 120px;
      		height: 112px;
      		background: #5397F7;
      		display: flex;
      		align-items: center;
      		justify-content: center;
      		border-radius: 3px;
      		img {
      			display: inline-block;
      			width: 65px;
      			height: 65px;
      			margin-left: 14px;
      		}
      	}
      	.right {
      		margin-left: 14px;
      		li {
      			&:nth-child(1) {
      				color: #0D141E;
      				font-size: 14px;
      			}
      			&:nth-child(2) {
      				color: #858C96;
      				font-size: 12px;
      				margin: 16px 0;
      			}
      			&:nth-child(3) {
      				.el-button {
      					padding: 7px 8px;
      					background: #5397F7;
      					border: 0;
      				}
      				.del {
      					background: #F77981;
      				}
      			}
      		}
      	}
      }
    }
    /deep/ .el-drawer {
			width: 80% !important;
		}
		.drawer_content {
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 1px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D0D0D;
					font-weight: bold;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
				.btn {
					.el-button {
						padding: 7px 23px;
						background: #5397F7;
						color: #fff;
					}
				}
			}
			.search_ipt {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin-top: 14px;
				padding-left: 37px;
				h3 {
					font-size: 12px;
					color: #0D141E;
					font-weight: bold;
				}
				.ipt {
					margin-right: 20px;
					/deep/ .el-input {
						width: 190px;
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border: 0;
							background: #F1F2F4;
						}
						.el-input__icon {
							line-height: 28px;
						}
					}
				}
				.btn {
					.el-button {
						background: #5397F7;
						color: #fff;
						padding: 7px 14px;
					}
				}
			}
			.table {
				margin-top: 12px;
				padding: 0 24px;
				overflow-y: auto;
				.header_title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					p {
						font-size:12px;
	          color:rgba(93,100,110,1);
	          text-align: left;
	          &:nth-child(1){ width: 60px; }
	          &:nth-child(2){ flex: 1; padding: 0 16px; box-sizing: border-box; }
	          &:nth-child(3){ width: 15%; }
	          &:nth-child(4){ width: 15%; }
	          &:nth-child(5){ width: 20%; }
					}
				}
				.teach_class {
					.tab_item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height:40px;
						background:rgba(246,248,251,1);
						border-radius:4px;
						margin: 8px 0;
						&:hover {
							background: #E9EEF5;
						}
						p {
							font-size:12px;
		          color: #0D141E;
		          text-align: left;
		          &:nth-child(1){ width: 60px; text-align: center;}
		          &:nth-child(2){ flex: 1; padding: 0 16px; box-sizing: border-box; }
		          &:nth-child(3){ width: 15%; }
		          &:nth-child(4){ width: 15%; }
		          &:nth-child(5){ width: 20%; }
						}
					}
				}
			}
			.pages-cont {
				padding: 0 18px;
			}
		}
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/addTestpaper.vue